import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import SectionList from './section-list.component';
import SectionCreate from './section-create.component';
import SectionView from './section-view.component';
import SectionEdit from './section-edit.component';
import SectionCopy from './section-copy.component';
import SectionDelete from './section-delete.component';

interface Props {
  root?: string;
}

export const SectionRoute: React.FunctionComponent<Props> = (props) => {
  return (
    <Switch>
      <Route path={(props.root||'') + '/section/create'} component={SectionCreate} />
      <Route path={`${props.root||''}/section/view`} render={(params) => <SectionView {...params} key={params.history.location.key} root={props.root} />} />        
      <Route path={`${props.root||''}/section/edit`} render={(params) => <SectionEdit {...params} key={params.history.location.key} root={props.root} />} />        
      <Route path={`${props.root||''}/section/copy`} component={SectionCopy} />
      <Route path={`${props.root||''}/section/delete`} render={(params) => <SectionDelete {...params} key={params.history.location.key} root={props.root} />} />        
      <Route path={(props.root||'') + '/section'} render={(params) => <SectionList {...params} root={props.root} />} /> 
    </Switch>
  );
}
